
import $ from 'jquery';
import { validateEmail } from "./dataHelpers";
import { SCENE_EVENTS } from './Model';

const guestHelper = (data) => `
<div class="contributore-flex-container">
  <div class="contributore-flex-items">
    <span>${data.email}</span>
  </div>
  <div class="contributore-flex-items">
      <div class="delete_room_guest guest_add_as_guest">
      <span class='material-icons-outlined' id='remove-visitor-${data.id}' title="Delete thumbnail image" data-lang="delete-thumbnail-img-title">delete</span>
    </div>
  </div>
</div>
`;
class RoomGuestHelper {

  constructor({ model }) {
    this.model = model;
    this.items = [];
    this.container = $(document).find("#world_room_list");
    this.contributores = null;
    this.appUsers = null;
    this.filtered = [];
    this.dropdowns = [];
    this.modal = $(".modal.room_guests_holder");


    const onClickedItem = (item, input) => {
      this.container.hide();
      const worldId = this.model.URLS.ID;
      this.model.worldFetcher.removeGuestVisitors(item.id, worldId, () => {
        this.model.worldFetcher.getGuestVisitors(this.model.URLS.ID, onContributores, onContributores);
      })
    }

    this.onDropdownClick = (e) => {
      if ($(e.target).is(".contributores-dropdown") || $(e.target).is(".contributores-dropdown div") || $(e.target).is(".contributores-info")) {
        return
      }
      this.dropdowns.forEach(item => {
        item.hide();
        item.removeClass("active");
      })
    }
    $(document.body).on("click", this.onDropdownClick)


    const onUsers = (response) => {
      // model.appUsers = response;
      // this.filtered = [{ "id": "2", "email": "a.haaken@aptis.info" }, { "id": "54", "email": "adityat1993@gmail.com" }, { "id": "58", "email": "ajaykantkanojiya@gmail.com" }, { "id": "76", "email": "alexandru.marincas@alten.com" }, { "id": "78", "email": "ana.duspara@speck.agency" }, { "id": "85", "email": "ana@inorbit.hr" }, { "id": "66", "email": "anana.duspara@gmail.com" }, { "id": "81", "email": "anana@test.com" }, { "id": "82", "email": "anatest4@ana.com" }, { "id": "80", "email": "anatester@ana.com" }, { "id": "75", "email": "bojan.ratkovic@speck.agency" }, { "id": "86", "email": "eduardo.maric@speck.agency" }, { "id": "5", "email": "fuldner@a-t.de" }, { "id": "52", "email": "gunjan.shahane@gmail.com" }, { "id": "51", "email": "gunjan.shahane@mindcrewtech.com" }, { "id": "6", "email": "info@albanese-music.de" }, { "id": "77", "email": "info@inorbit.hr" }, { "id": "84", "email": "inorbit.doo@gmail.com" }, { "id": "50", "email": "maroofahmed.siddique@mindcrewtech.com" }, { "id": "53", "email": "maroofahmedsiddique@gmail.com" }, { "id": "57", "email": "mindcrew.technologies@gmail.com" }, { "id": "83", "email": "minomaximus@gmail.com" }, { "id": "65", "email": "nahar321@gmail.com" }, { "id": "88", "email": "nikola.krtalic@speck.agency" }, { "id": "55", "email": "prakhar.kp@gmail.com" }, { "id": "11", "email": "raihanrobi17@gmail.com" }, { "id": "1", "email": "s.stamprath@aptis.info" }, { "id": "9", "email": "s.stamprath+2222@aptis.info" }, { "id": "59", "email": "s.stamprath+bagless@aptis.info" }, { "id": "49", "email": "s.stamprath+end@aptis.info" }, { "id": "10", "email": "saenger@a-t.de" }, { "id": "13", "email": "sunwarrior3206@gmail.com" }, { "id": "18", "email": "test@test.bd" }, { "id": "17", "email": "test@test.com" }, { "id": "12", "email": "test@test.se" }, { "id": "22", "email": "test@test.sebd" }, { "id": "19", "email": "test@test.see" }, { "id": "14", "email": "test@test.seeee" }, { "id": "16", "email": "test@test.seeeee" }, { "id": "15", "email": "test@test.seeeeeee" }, { "id": "21", "email": "test@test.seeeeeeeeeeee" }, { "id": "64", "email": "test24396113@wintds.org" }, { "id": "62", "email": "test29944161@wintds.org" }, { "id": "79", "email": "test3@test.com" }, { "id": "63", "email": "test38546189@wintds.org" }, { "id": "60", "email": "test46522757@wintds.org" }, { "id": "61", "email": "test7084707@wintds.org" }]
      if (!this.filtered) {
        return
      }
      $(document).find("#world_room_list").empty();
      this.items.forEach(item => {
        item.off("click");
        item.children().off();
      })
      this.items = [];

      this.filtered.map(item => {
        const label = $(guestHelper(item));
        const input = label.find(".delete_room_guest");

        input.on("click", (e) => {
          onClickedItem(item, input)
        })

        this.items.push(label);
        $(document).find("#world_room_list").append(label)
      })
    };
    onUsers();

    const onContributores = (response) => {
      this.container.show();
      if (!Array.isArray(response)) {
        return;
      }
      this.filtered = response;
      onUsers();
    }
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {

    } else {

      this.model.worldFetcher.getGuestVisitors(this.model.URLS.ID, onContributores, onContributores);
    }

    const onFindCallback = (response) => {

      this.container.show();
      $("#contributore_email").val("");
      if (response.success === true) {
        this.model.worldFetcher.addAsGuest(Number(response.data.id), this.model.URLS.ID,
          () => {
            this.model.info('success', `User added to guest list`);
            this.model.worldFetcher.getGuestVisitors(this.model.URLS.ID, onContributores, onContributores);
          }, onContributores);
        this.model.dispatchEvent({ type: SCENE_EVENTS.SCENE_EDIT_DATA_CHANGED });
        this.model.info('success', `Adding ${response.data.email} to guest list`);
      }
      else {
        this.model.alert('error', $trans('error-user-dont-exist'));
      }
    }

    $("#edit_room_guest").on("click", () => {
      this.modal.addClass("is-active");
      this.modal.show();
      return;
    });

    $("#copy_embeded_web").on("click", () => {
      // this.model.confirm($trans('private-rooms-available'), () => {
      //   const _t = document.getElementById("copy_embeded_web_descitprion")
      //   _t.select();
      //   navigator.clipboard.writeText(_t.value)
      //     .then(function () {
      //       this.model.info('info', `${$trans('link-copied')}`);
      //     })
      //     .catch(function (err) {
      //       alert("Unable to copy text to clipboard. Please copy it manually.");
      //     });
      // });
      $('#copy_embeded_web_descitprion').toggleClass('hidden');
      if ($('#copy_embeded_web_descitprion').hasClass("hidden")) {
        $('#copy_embeded_web').html("Show")
      } else {
        $('#copy_embeded_web').html("Hide")
      }

    });

    $("#add_room_guests").on("click", () => {


      this.container.hide();
      const email = $("#guests_email").val();
      if (!validateEmail(email)) {
        this.model.alert('error', $trans('error-invalid-email'));
        this.container.show();
        return;
      }
      const emailExists = this.filtered && this.filtered.filter(user => user.email === email)[0]
      if (emailExists) {
        this.model.alert('error', `Duplicate entry`);
        this.container.show();
        return;
      }
      const worldId = this.model.URLS.ID;
      this.model.worldFetcher.findOneUserByEmail(email, onFindCallback, onFindCallback)
    });
  }

}

export { RoomGuestHelper }